import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PaymentMethod {
  documentOwner: string;
  id: number;
  description: string;
  internalCode: number;
}

interface PaymentMethodsState {
  paymentMethods: PaymentMethod[];
  isLoading: boolean;
  error: string | null;
}

const initialState: PaymentMethodsState = {
  paymentMethods: [],
  isLoading: false,
  error: null,
};

const paymentMethodsSlice = createSlice({
  name: "paymentMethods",
  initialState,
  reducers: {
    setPaymentMethods(state, action: PayloadAction<PaymentMethod[]>) {
      state.paymentMethods = action.payload;
      state.error = null;
    },
    clearPaymentMethods(state) {
      state.paymentMethods = [];
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setError(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

export const { setPaymentMethods, clearPaymentMethods, setLoading, setError, clearError } =
  paymentMethodsSlice.actions;
export default paymentMethodsSlice.reducer;
